import {Component, Inject, Input, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {DcpError} from '@dcp/configurator';

/**
 * Error-page for generic errors used as a fallback
 */
@Component({
    selector: 'dcp-default-configurator-error',
    templateUrl: './default-configurator-error.component.html',
    styleUrls: ['./default-configurator-error.component.scss'],
    standalone: false
})
export class DefaultConfiguratorErrorComponent {
  private _error: DcpError;
  @Input()
  set error(err: DcpError | any) {
    this._error = err;
    if (err.message) {
      this._error.description = err.message;
    }
  }
  get error() {
    return this._error;
  }

  @Input() titleDisplay: false;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  tryAgain() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.reload();
    }
  }
}
